import {
  canonicalInitialState,
  canonicalReducer,
} from '@doda/common/src/redux/features/canonical';

import {
  memberInfoReducer,
  memberInfoInitialState,
} from '@doda/common/src/redux/features/memberInfo';
import {
  queryParamsReducer,
  queryParamsInitialState,
} from '@doda/common/src/redux/features/queryParams';
import {
  seoTextReducer,
  seoTextInitialState,
} from '@doda/common/src/redux/features/seoText';
import { hydrateReducer } from '@doda/common/src/redux/utils/hydrateReducer';
import { combineReducers } from '@reduxjs/toolkit';
import {
  jobListReducer,
  initialState as jobListInitialState,
} from 'redux/features/jobList';
import {
  rewritesUrlReducer,
  rewritesUrlInitialState,
} from 'redux/features/rewritesUrl';
import {
  searchLabelReducer,
  searchLabelInitialState,
} from '@doda/common/src/redux/features/searchConditionLabel';
import {
  analyticsInitialState,
  analyticsReducer,
} from '@doda/common/src/redux/features/analytics';
import {
  careerRecommendJobListInitialState,
  careerRecommendJobListReducer,
} from 'redux/features/careerRecommendJobList';

const reducers = combineReducers({
  queryParams: queryParamsReducer,
  memberInfo: memberInfoReducer,
  jobList: jobListReducer,
  rewritesUrl: rewritesUrlReducer,
  canonical: canonicalReducer,
  seoText: seoTextReducer,
  searchLabel: searchLabelReducer,
  analytics: analyticsReducer,
  careerRecommendJobList: careerRecommendJobListReducer,
});

const initialState = {
  queryParams: queryParamsInitialState,
  memberInfo: memberInfoInitialState,
  jobList: jobListInitialState,
  rewritesUrl: rewritesUrlInitialState,
  canonical: canonicalInitialState,
  seoText: seoTextInitialState,
  searchLabel: searchLabelInitialState,
  analytics: analyticsInitialState,
  careerRecommendJobList: careerRecommendJobListInitialState,
};

export const reducer = hydrateReducer(reducers, initialState);

export type CareerRecommendJobListRootState = ReturnType<typeof reducer>;
